import { lazy } from "react";

export { INTERVIEWS_PATH } from "./interviews-path";
export const InterviewsPage = lazy(() => import("./interviews"));
